<script lang="ts">
  export let show;
  export let htmlId;
  export let checked;
  export let onChange;
  export let text;
  export let name;
  export let count;

</script>

{#if show}
  <dt class="side-filter__item">
    <label class="fizz-flex-row-8 fizz-stack-4 cursor-pointer" for={htmlId}>
      <input
        id={htmlId}
        {name}
        type="checkbox"
        class="fizz-checkbox"
        bind:checked
        on:change={onChange}
      />
      <span class="side-filter-list-item font-weight-normal">{text}</span>
      <span class="fizz-text-subdued" style="margin-left: auto">({count})</span>
    </label>
  </dt>
{/if}
